<template>
	<include-header-main />

	<section id="join">
		<form ref="form_pre_register" id="form_pre_register" @submit.prevent="register_next()" action="/register_form"
			method="post" autocomplete="off">
			<input type="hidden" v-model="mb_type">
		</form>

		<div class="join_inner">
			<div class="main_tit"><span>덴탈클라우드</span> 회원가입</div>
			<div class="join_dental join_btn" @click="register_next('dental_hospital')">치과 전용 회원가입</div>
			<div class="join_lab join_btn" @click="register_next('dental_lab')">기공소 전용 회원가입</div>
			<div class="login_txt">
				<div class="member_txt">이미 덴탈클라우드 회원이세요?</div>
				<div class="login" @click="goto_login()">로그인</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header_main from '../components/layout/header-main.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header-main': header_main,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';

const route = useRoute();
const router = useRouter();

const form_pre_register = ref(null);
const mb_type = ref(null);

const goto_login = () => {
	router.push('/login');
};

function register_next(type) {
console.log(type);
	mb_type.value = type;
	router.push(`/register_form/${type}`);
}
</script>